import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { IError } from "itsf-ui-common";
import { IAddress } from "@interface/customerDetails/IAddress";

export const mapEirSalesPrequalWithError = (address: IAddress, apiError: IError): IEirSalesPrequal => ({
    hasBroadbandService: false,
    address: {
        eircode: address.eircode,
        county: address.county,
        town: address.town,
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        addressLine3: address.addressLine3,
    },
    prequalError: apiError.errorCode,
});
